// 手机
const mobilereg = /^1[345789]\d{9}$/;
// 密码
const passwordreg = /^(?![0-9]+$)(?![a-z]+$)(?!([^(0-9a-z)])+$).{6,20}$/;
// 百分比（0-1，两位小数）
const percentagereg = /^[0](\.[0-9]{1,2}){0,1}$/;
// 最多两位小数
const twoPointreg = /^(\d+|\d+\.\d{1,2})$/;
// 数量 两位小数 最小0最大999999999999.99
const numberreg = /^[0-9]{1,12}(\.\d{1,2})?$/;
// 数量 三位小数 最小0最大999999999999.999
const numberreg3 = /^[0-9]{1,12}(\.\d{1,3})?$/;
// 数量 四位小数 最小0最大999999999999.9999
const numberreg4 = /^[0-9]{1,12}(\.\d{1,4})?$/;
// 数量 最小0最大99999999
const numberreg9 = /^(\d{1,8})$/;
// 正整数
const intreg = /^[1-9]\d*$/;
// 邮箱
const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// 0-100
const percent = /^(?:0|[1-9][0-9]?|99)$/;
// Exchange Rate
const exchangeRate = /^([1-9]{0,6}(\.\d{1,4})?|([0](\.([0][1-9]|[1-9]\d{0,3}))))$/;
// 3-20
const doMainReg = /^[0-9|a-z|_|-]{3,20}$/;

export default {
  mobilereg,
  passwordreg,
  percentagereg,
  twoPointreg,
  intreg,
  email,
  percent,
  numberreg,
  numberreg3,
  numberreg4,
  numberreg9,
  exchangeRate,
  doMainReg
};